import React, { useEffect, useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { useDispatch, useSelector } from 'react-redux';
import { adPaymentOptionRequest, paymentOptionLisitingRequest } from './redux/paymentOptionDispatcher';
import { toast } from 'react-toastify';

const PaymentOption = () => {
    const dispatch = useDispatch();
    const gdprListing = useSelector((state) => state.paymentOptionReducer?.paymentOptionListing || []);
  const [loading, setLoading] = useState(false);

    const [htmlContent, setHtmlContent] = useState('');

    useEffect(() => {
        dispatch(paymentOptionLisitingRequest());
    }, [dispatch]);

    useEffect(() => {
        console.log("DATDTADTADTADADTATATTA:::::::", gdprListing);
        if (gdprListing.length > 0) {
            setHtmlContent(gdprListing[0].html_text || '');
        }
    }, [gdprListing]);

  const handleSave = async () => {
    setLoading(true);

    const data = {
      html_text: htmlContent,
      gdpr_key: "payment-option",
    };

    if (gdprListing.length > 0 && gdprListing[0]?.id) {
      data.id = gdprListing[0].id;
    }

    try {
      await dispatch(adPaymentOptionRequest(data));
    } finally {
      setLoading(false);
      toast.success("Payment Option Updated Successfully");
    }
  };
    return (
        <div style={{ padding: '20px', maxWidth: '900px', margin: 'auto' }}>
            <h3 style={{ marginBottom: '16px' }}>Payment Option HTML Editor</h3>

            <CKEditor
                editor={ClassicEditor}
                data={htmlContent}
                onChange={(event, editor) => {
                    setHtmlContent(editor.getData());
                }}
            />

            <button
      onClick={handleSave}
      disabled={loading}
      style={{
        marginTop: "20px",
        backgroundColor: loading ? "#555" : "#000",
        color: "#fff",
        border: "none",
        padding: "10px 24px",
        borderRadius: "5px",
        cursor: loading ? "not-allowed" : "pointer",
        opacity: loading ? 0.8 : 1,
      }}
    >
      {loading ? "Saving..." : "Save Payment Option"}
    </button>
        </div>
    );
};

export default PaymentOption;
